/**
 * @desc deliveryOutPlan
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OutPlanMasterCreateRequestRpcDto, options?: any) {
  return updateResponse(
    http(URL + `/Batch/delivery/out`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
